import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appRequired]',
})
export class RequiredDirective {
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const span: HTMLParagraphElement = this.renderer.createElement('span');
    span.innerHTML = '*';
    span.className = 'required';
    this.renderer.appendChild(this.elementRef.nativeElement, span);
  }
}
